import { useEffect } from "react";
import { CONFIG } from "../config";
import { useAppState } from "../context/AppContext";

export const useLoadProjectMeta = () => {
  const { dispatch } = useAppState();

  const loadData = async () => {
    await Excel.run(async (context) => {
      const worksheet = context.workbook.worksheets.getItem(CONFIG.PROJECT_SHEET_NAME);
      const allRows = worksheet.getRange("B2:B4");
      allRows.load("values");
      await context.sync();
      const values = allRows.values as any;
      dispatch(["SET_PROJECT_META", { projectNumber: values[0][0], projectName: values[1][0] }]);
    });
  };

  useEffect(() => {
    void loadData();
  }, []);

  return { reload: loadData };
};
